import { Controller } from "@hotwired/stimulus";
import { rememberLocale } from "./locale_cookie";

// The language select holds the same page in each language as option values.
// A full load, not Turbo, so everything outside <body> follows the language too.
export default class extends Controller {
  go() {
    rememberLocale(this.element.selectedOptions[0].lang);
    window.location.assign(this.element.value);
  }
}
